/**
 * index.jsx
 * React 18 entry point
 * Providers wrap App EXACTLY ONCE
 */

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

import { AuthProvider } from "./context/AuthContext";
import { SponsorProvider } from "./context/SponsorContext";

import "./index.css";
import "./App.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Missing #root element in public/index.html");
}

createRoot(rootElement).render(
  <React.StrictMode>
    <AuthProvider>
      <SponsorProvider>
        <App />
      </SponsorProvider>
    </AuthProvider>
  </React.StrictMode>
);
